module.exports = __webpack_public_path__ + "img/ac-logo-short.f5b16319.png";